import script from "./Page4.vue?vue&type=script&setup=true&lang=js"
export * from "./Page4.vue?vue&type=script&setup=true&lang=js"

import "./Page4.vue?vue&type=style&index=0&id=6de6dbc4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6de6dbc4"]])

export default __exports__